<div class="flex flex-row">
  <div class="w-1/3">
    <app-card>
      <div>
        <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md mb-2">
          {{ 'settings.system.tableconfigurations' | translate }}
        </div>

        @if (tableSettings.length > 0) {
          <div class="flex flex-col gap-4">
            @for (element of tableSettings; track element.tableId) {
              <div class="bg-gray-50 dark:bg-dark-hover flex justify-between py-2 px-3 rounded w-full">
                {{ (element.settings.title ?? element.tableId) | translate }}
                <a
                  href="#"
                  class="text-gray-400 dark:text-dark-muted hover:text-red-500"
                  (click)="$event.preventDefault(); clearTableConfiguration(element.tableId)"
                  [title]="'common.reset' | translate"
                >
                  <lucide-angular [name]="Trash" size="16"></lucide-angular>
                </a>
              </div>
            }

            <div class="text-right">
              <a href="#" (click)="$event.preventDefault(); clearTableConfigurations()" class="text-gray-500 dark:text-dark-muted underline">
                {{ 'common.resetall' | translate }}
              </a>
            </div>
          </div>
        } @else {
          <div class="font-semibold text-gray-500 dark:text-dark-muted text-center">
            {{ 'settings.system.notableconfiguration' | translate }}
          </div>
        }
      </div>
    </app-card>
  </div>
</div>
